module.exports = __webpack_public_path__ + "img/ic-eye.54df59b2.svg";